import { useTheme } from "@mui/material";
import { ComponentsTheme } from "@bn/theming";

export const useChartColors = <T extends keyof ComponentsTheme["charts"]>(
  type: T
): ComponentsTheme["charts"][T] => {
  const theme = useTheme();
  return theme.charts[type];
};
